// ============================================================
// Tipos y constantes para días de la semana
// ============================================================

export type DiaSemana =
  | 'lunes'
  | 'martes'
  | 'miércoles'
  | 'jueves'
  | 'viernes'
  | 'sábado'
  | 'domingo';

export const DIAS_SEMANA: DiaSemana[] = [
  'lunes',
  'martes',
  'miércoles',
  'jueves',
  'viernes',
  'sábado',
  'domingo',
];

export const DIA_A_INDEX: Record<DiaSemana, number> = {
  lunes: 0,
  martes: 1,
  miércoles: 2,
  jueves: 3,
  viernes: 4,
  sábado: 5,
  domingo: 6,
};

export const MAPEO_FULLCALENDAR: Record<number, number> = {
  0: 1, // lunes
  1: 2, // martes
  2: 3, // miércoles
  3: 4, // jueves
  4: 5, // viernes
  5: 6, // sábado
  6: 0, // domingo
};
